<template>
  <div class="uploader">
    <form enctype="multipart/form-data" novalidate class="m-0 p-0">
      <div class="dropbox">
        <input id="uploader" class="file-input" type="file" :disabled="isSaving" @change="filesChange($event.target.files)" :accept="acceptType" ref="uploader"/>
        <div class="image-selector pointer" @click="$refs.uploader.click()">
          <i class="fas fa-file-upload"></i>
          <span class="mx-2" v-if="isInitial">{{$t('designer.uploader.toUpload')}}</span>
          <span class="mx-2" v-if="isSaving">{{$t('designer.uploader.isSaving', { name: fileName })}}</span>
          <span class="mx-2" v-if="isSuccess">{{$t('designer.uploader.isSuccess', { name: fileName })}}</span>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import i18n from './i18n'
import Vue from 'vue'
const MAX_SIZE = 2097152
const STATUS_INITIAL = 0
const STATUS_SAVING = 1
const STATUS_SUCCESS = 2
const STATUS_FAILED = 3

export const isImage = (data) => data.startsWith('data:image')
export const isHTML = (data) => data.startsWith('data:text/html')
export const isJavascript = (data) => data.startsWith('data:text/javascript')
export const isJSON = (data) => data.startsWith('data:application/json')
export const isCSS = (data) => data.startsWith('data:text/css')

export default {
  name: 'uploader',
  props: {
    acceptType: {
      required: false,
      default: 'application/zip',
      type: String
    }
  },
  data () {
    return {
      currentStatus: null,
      fileName: ''
    }
  },
  computed: {
    isInitial () {
      return this.currentStatus === STATUS_INITIAL
    },
    isSaving () {
      return this.currentStatus === STATUS_SAVING
    },
    isSuccess () {
      return this.currentStatus === STATUS_SUCCESS
    },
    isFailed () {
      return this.currentStatus === STATUS_FAILED
    }
  },
  methods: {
    onInitComponent () {
      this.$servicesPLK.translation.init(i18n, { overwrite: false })
      this.reset()
    },
    reset () {
      // reset form to initial state
      this.currentStatus = STATUS_INITIAL
    },
    uploadOk () {
      // reset form to initial file content, to detect again the same file
      this.currentStatus = STATUS_SUCCESS
      const uploader = this.$refs.uploader
      uploader.type = 'text'
      uploader.type = 'file'
    },
    filesChange (fileList) {
      this.currentStatus = STATUS_SAVING
      if (!fileList.length) {
        this.reset()
        return
      }
      Vue.set(this, 'fileName', fileList[0].name)
      this.getFileAnyType(fileList)
    },
    getFileAnyType (fileList) {
      let reader = new FileReader()
      reader.onload = (e) => {
        let file = fileList[0]
        if (file.size === 0) {
          this.$servicesPLK.event.emitEvent(this.$servicesPLK.event.BASIC_ACTIONS.ERROR, { type: 'error', msg: 'designer.uploader.erroremptyfile' })
          this.currentStatus = STATUS_FAILED
          return
        }
        if (file.size > MAX_SIZE) {
          this.$servicesPLK.event.emitEvent(this.$servicesPLK.event.BASIC_ACTIONS.ERROR, { type: 'error', msg: 'designer.uploader.errormaxsize' })
          this.currentStatus = STATUS_FAILED
          return
        }
        if (this.acceptType.indexOf(file.type) === -1) {
          this.$servicesPLK.event.emitEvent(this.$servicesPLK.event.BASIC_ACTIONS.ERROR, { type: 'error', msg: 'designer.uploader.invalidType' })
          this.currentStatus = STATUS_FAILED
          return
        }
        try {
          const typeImage = isImage(e.currentTarget.result)
          const typeHtml = isHTML(e.currentTarget.result)
          const typeJavascript = isJavascript(e.currentTarget.result)
          const typeJSON = isJSON(e.currentTarget.result)
          const typeCSS = isCSS(e.currentTarget.result)

          let data = {
            data: typeImage ? e.currentTarget.result : decodeURIComponent(escape(atob(e.currentTarget.result.split(',')[1]))),
            base64Data: e.currentTarget.result,
            isImage: typeImage,
            isHtml: typeHtml,
            isJavascript: typeJavascript,
            isJSON: typeJSON,
            isCSS: typeCSS
          }
          this.uploadOk()
          this.$emit('loadFile', { filename: fileList[0].name, content: data })
        } catch (e) {
          this.currentStatus = STATUS_FAILED
          this.$servicesPLK.event.emitEvent(this.$servicesPLK.event.BASIC_ACTIONS.ERROR, { type: 'error', msg: 'designer.uploader.errorreadingfile' })
        }
      }
      reader.readAsDataURL(fileList[0])
    }
  }
}
</script>

<style scoped lang="scss">
  @import '@/assets/styles/designcolor.scss';
  .uploader {
    .image-selector:hover {
      color: $color-base;
    }
    [type="file"] {
      display: none;
    }
  }
</style>
